module.exports = __webpack_public_path__ + "static/media/Blue-B.eadb46b6.png";